import { render, staticRenderFns } from "./IssuesRenderer.vue?vue&type=template&id=31f8a8d9&scoped=true"
import script from "./IssuesRenderer.vue?vue&type=script&lang=js"
export * from "./IssuesRenderer.vue?vue&type=script&lang=js"
import style0 from "./IssuesRenderer.vue?vue&type=style&index=0&id=31f8a8d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f8a8d9",
  null
  
)

export default component.exports